import { Widget } from '@typeform/embed-react';
import { useReportContext } from '../report-context';

export const FeedbackForm = () => {
  const { test, baby, parent } = useReportContext();

  return (
    <Widget
      id="jbBuiSit"
      className="h-[440px] mb-5 md:h-[420px] lg:h-[470px] lg:mb-0 relative z-20"
      hidden={{ id: test.id, parent: parent.name, baby: baby.name }}
      style={{ width: '100%' }}
    />
  );
};
